export enum PerfType {
    STANDARD = "standard",
    ENERGIZER = "energizer"
}